
import React from 'react'
import {AppForm,AppFormItemEnum,AppFormLayout,AppGridTabs,AppButton,AppRow} from 'qcc'
import { Row } from 'antd';

const options = [{label:'选项1',value:'选项1'},{label:'选项2',value:'选项2'}]

export const AppFormDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>使用说明</h1>    
            <div>
                1、表单输入框，需要用户界面交互时使用。<br/>
                2、引用：import {`{AppForm}`} from 'qcc'<br/>
                3、demo位置：src/demo/components/AppFormDemo.tsx<br/>
                4、扩展的类型如果要使用AppForm统一功能，可以使用AppFrom提供者进行交互<br/>
                5、整体布局就使用AppFormLayout<br/>
            </div>

            <h1>DEMO</h1>
            <div className='app-demo-content-demo'>
                <Row style={{padding:20}}>
                    <AppFormLayout>
                        <AppFormLayout.Header>
                            <AppGridTabs tabs={['主要信息','视图2','视图3','视图4']}/>
                        </AppFormLayout.Header>
                        <AppFormLayout.Form>
                            <AppForm>
                                <AppForm.Section labelWidth={100} colNumber={2}>
                                    <AppForm.Item field='input' itemType={AppFormItemEnum.input} label="input-text"/>
                                    <AppForm.Item field='inputnumber' itemType={AppFormItemEnum.input} label="input-number" dataType='number'/>
                                    <AppForm.Item field='radio' itemType={AppFormItemEnum.radio} label="radio" />
                                    <AppForm.Item field='select' itemType={AppFormItemEnum.select} label="select" options={options} />
                                </AppForm.Section>
                            </AppForm>
                        </AppFormLayout.Form>
                        <AppFormLayout.Footer>
                            <AppRow>
                                <AppButton label="保存" type='primary'/> 
                                <AppButton label="关闭"/>
                            </AppRow>
                        </AppFormLayout.Footer>
                    </AppFormLayout>
                   
                  
                </Row>
            </div>

    </div>)
}


// WEBPACK FOOTER //
// ./src/demo/components/AppFormDemo.tsx